/**
 * ========================
 * user 模型
 * ========================
 */

const state = {
  // 用户ID
  userId: '',
  // 用户角色
  userRole: '',
  // 管理菜单大小切换 （默认小的的）
  menuStatus: false,
  // 用户添加活动表单数据
  LiveForm: {},
  // 七牛图片压缩函数 100x 为宽度100px 高度自适应
  qiniuPicSmall: '?imageMogr2/auto-orient/thumbnail/300x/format/jpeg/interlace/1/blur/1x0/quality/62|imageslim',
  qiniuPicBig: '?imageMogr2/auto-orient/thumbnail/500x/format/jpeg/interlace/1/blur/1x0/quality/62|imageslim',
  qiniuPicView: '?imageMogr2/auto-orient/thumbnail/1000x/format/jpeg/interlace/1/blur/1x0/quality/62|imageslim'
}

const mutations = {
  setUserId (state, res) {
    state.userId = res
  },
  setUserRole (state, res) {
    state.userRole = res
  },
  setMenuStatus (state, res) {
    state.menuStatus = res
  },
  setLiveForm (state, res) {
    state.LiveForm = res
  },
  setQiniuPicSmall (state, res) {
    state.qiniuPicSmall = res
  },
  setQiniuPicBig (state, res) {
    state.qiniuPicBig = res
  },
  setQiniuPicView (state, res) {
    state.qiniuPicView = res
  },
  setAddressData (state, res) {
    state.addressData = res
  }
}
const actions = {
  'setUserId': function ({
    commit
  }, res) {
    commit('setUserId', res)
  },
  'setUserRole': function ({
    commit
  }, res) {
    commit('setUserRole', res)
  },
  'setMenuStatus': function ({
    commit
  }, res) {
    commit('setMenuStatus', res)
  },
  'setLiveForm': function ({
    commit
  }, res) {
    commit('setLiveForm', res)
  },
  'qiniuPicSmall': function ({
    commit
  }, res) {
    commit('qiniuPicSmall', res)
  },
  'qiniuPicBig': function ({
    commit
  }, res) {
    commit('qiniuPicBig', res)
  },
  'qiniuPicView': function ({
    commit
  }, res) {
    commit('qiniuPicView', res)
  },
  'setAddressData': function ({
    commit
  }, res) {
    commit('setAddressData', res)
  }
}

const getters = {
  userId: state => state.userId,
  userRole: state => state.userRole,
  menuStatus: state => state.menuStatus,
  LiveForm: state => state.LiveForm,
  qiniuPicSmall: state => state.qiniuPicSmall,
  qiniuPicBig: state => state.qiniuPicBig,
  qiniuPicView: state => state.qiniuPicView,
  addressData: state => state.addressData
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js